import { createSlice } from "@reduxjs/toolkit";

const initialState = {
};

export const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      return { ...action.payload }; // This replaces the state entirely
    },
    resetFilters: (state) => {
      return initialState; // Reset to initial state
    },
    updateFilters: (state, action) => {
      Object.assign(state, action.payload); // Merge new filters into the current state
    },
    deleteFilters: (state, action) => {
      Object.keys(action.payload).forEach((filterKey) => {
        delete state[filterKey]; // Remove each specified filter
      });
    },
    updateAndDeleteFilters: (state, action) => {
      const { updates, deletes } = action.payload;

      // Update filters
      Object.entries(updates).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          state[key] = value;
        }
      });

      // Delete specified filters
      deletes.forEach((key) => {
        delete state[key];
      });
    },
  },
});

export const { setFilters, resetFilters, updateFilters, deleteFilters } =
  filtersSlice.actions;

export default filtersSlice.reducer;
